import { related, sourceIds } from './quests__into-the-sinkhole.mdx';

export { sourceIds, related };
export const quickAnswer =
  '护送探针、完成遭遇战，放置并启动四个中继装置，再沿新平台和音乐提示离开。';

## 任务前置与位置

该任务接在 Arish’s Briefing 后，属于 Contain the Crisis。Sinkhole 位于 Evacuation Zone。

## Probe Relays 怎么完成？

每次遭遇战结束后操作下降探针的控制装置。到底部后，将每个中继装置搬到标记处，绿灯用于确认放置。放好后还要启动背面的开关。

## 怎么逃出 Sinkhole？

四个中继都安装完后，完成后续战斗。出现的平台用于向上攀爬，沿发光线缆前进，等待旋转折射打开后再穿过。

## Follow the Music 怎么走？

到上方后沿播放音乐的发光电视前进，直至到达外部。

## 卡关排查

装置放好仍需激活；逃离平台没出现时，检查是否还有敌人。最终路线不清楚时跟随电视提示，不要沿下来的路径倒走。

## 后续目标

完成后查看日志剩余任务，另一个相关目标见 [Power Lines](/quests/power-lines)。
